// SocialLoginRegistrer.jsx

import { useNavigate } from "react-router-dom";

import googleicon from "../../header/images/googleicon.png";
import linkedinicon from "../../imagesHome/share-linkedin.png";

import "./socialloginregistrer.css";

const apiUrl = process.env.REACT_APP_API_URL;

const SocialLoginRegistrer = ({ redirectToQuizStart = false }) => {
  const navigate = useNavigate();

  const handleGoogleLogin = () => {
    if (redirectToQuizStart) {
      navigate('/quiz-start');
      return;
    }

    window.location.href = `${apiUrl}/auth/google?flow=register`;
  };

  const handleLinkedInLogin = () => {
    if (redirectToQuizStart) {
      navigate('/quiz-start');
      return;
    }

    window.location.href = `${apiUrl}/auth/linkedin?flow=register`;
  };

  return (
    <div className="options-connect-registrer">
      {/* Google */}
      <div
        className="connect-social-registrer google-registrer"
        onClick={handleGoogleLogin}
      >
        <img src={googleicon} alt="google icon" />
        <span>Inregistrare cu Google</span>
      </div>

      {/* Linkedin */}
    
      <div className="connect-social-registrer fcbook-registrer" onClick={handleLinkedInLogin}>
              <img src={linkedinicon} alt="linkedin icon" />
              <span>Inregistrare cu LinkedIn</span>
            </div>


    </div>
  );
};

export default SocialLoginRegistrer;
